import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: '', stack: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || String(error) };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
    this.setState({ stack: (info?.componentStack || '').slice(0, 600) });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary-fallback" style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#FBFAF8', color: '#181A20', fontFamily: 'sans-serif', textAlign: 'center', padding: 24 }}>
          <div>
            <p style={{ fontSize: 22, fontWeight: 600, marginBottom: 8 }}>Ceva nu a mers bine.</p>
            <p style={{ color: '#6C727D', marginBottom: 16 }}>Reîncarcă pagina — dacă problema persistă, sună-ne la 0766 330 933.</p>
            <button onClick={() => window.location.reload()} style={{ background: '#C8102E', color: '#fff', border: 0, padding: '12px 28px', fontWeight: 700, cursor: 'pointer', textTransform: 'uppercase', letterSpacing: 2, fontSize: 12 }}>
              Reîncarcă pagina
            </button>
            <pre data-testid="error-boundary-details" style={{ marginTop: 24, fontSize: 11, color: '#9AA0A8', whiteSpace: 'pre-wrap', maxWidth: 520, textAlign: 'left', background: '#F4F3F1', padding: 12, overflow: 'auto' }}>
              {this.state.message}{'\n'}{this.state.stack}
            </pre>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
